import { b as __rest, a as __assign } from '../../../tslib.es6-a39f91fc.js';
import { jsx } from 'react/jsx-runtime';
import { c as classNames } from '../../../index-6ea95111.js';
import { s as styleInject } from '../../../style-inject.es-1f59c1d0.js';

var css_248z = ".styles-module_wrapper__1_lY0 {\n  margin: 4px;\n}";
var styles = {"wrapper":"styles-module_wrapper__1_lY0"};
styleInject(css_248z);

var IconWrapper = function (_a) {
    var _b;
    var children = _a.children, _c = _a.size, size = _c === void 0 ? 16 : _c, color = _a.color, className = _a.className, noMargin = _a.noMargin, rest = __rest(_a, ["children", "size", "color", "className", "noMargin"]);
    return (jsx("span", __assign({ className: classNames('d-inline-block', className !== null && className !== void 0 ? className : '', (_b = {},
            _b["tc-".concat(color)] = !!color,
            _b[styles.wrapper] = !noMargin,
            _b)), style: {
            minWidth: "".concat(size, "px"),
            width: "".concat(size, "px"),
            height: "".concat(size, "px")
        } }, rest, { children: jsx("svg", { className: 'w100', viewBox: "0 0 24 24", fill: "none", children: children }) })));
};

export { IconWrapper };
//# sourceMappingURL=IconWrapper.js.map
